import { Dispatch, SetStateAction } from 'react';
import { css } from '@linaria/atomic';
import { TableInstance } from 'react-table';
import { ButtonBar } from '../../buttons';
import { TextButton } from '../../text-button';
import { TableData } from '../table-data-type';
import { CollapsedTableConfig } from '../table-types';

const collapsibleButtonBarStyle = css`
  justify-content: right;
`;

type CollapsibleTableButtonProps<T extends TableData> = {
  tableInstance: TableInstance<T>;
  collapsedTableConfig: CollapsedTableConfig<T>;
  setIsCollapsed: Dispatch<SetStateAction<boolean>>;
  isCollapsed: boolean;
};

export const CollapsibleTableButton = <T extends TableData>({
  tableInstance,
  collapsedTableConfig,
  setIsCollapsed,
  isCollapsed,
}: CollapsibleTableButtonProps<T>) => {
  return (
    <ButtonBar className={collapsibleButtonBarStyle}>
      <TextButton
        onClick={() => {
          setIsCollapsed((currentState) => {
            if (currentState) {
              collapsedTableConfig?.onCollapse?.(tableInstance);
            }

            if (!currentState) {
              collapsedTableConfig?.onExpand?.(tableInstance);
            }

            return !currentState;
          });
        }}
      >
        {!isCollapsed
          ? collapsedTableConfig.expandLabel ?? 'Show More'
          : collapsedTableConfig.collapseLabel ?? 'Show Less'}
      </TextButton>
    </ButtonBar>
  );
};
